import { type StandardEventProperties, track } from '@betterment/js-runtime';

export function trackClick(properties: StandardEventProperties): void {
  track('ElementClicked', { interaction: 'click', ...properties });
}

export function trackHover(properties: StandardEventProperties): void {
  track('ElementHovered', properties);
}
